import { render, staticRenderFns } from "./TrangDanhSachQuyen.vue?vue&type=template&id=4b077cc4&"
import script from "./TrangDanhSachQuyen.vue?vue&type=script&lang=js&"
export * from "./TrangDanhSachQuyen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports